import { parseResponse } from "api/resources/handlers/parseResponse/parseResponse";
import {
  CreateTcuAppointmentRequestPayload,
  CreateTcuAppointmentResponsePayload,
} from "./createTcuAppointment.types";
import axios from "axios";
import { CREATE_TCU_APPOINTMENT } from "api/resources/configs/URL";
import { getRequestOptions } from "api/resources/configs/requests";
import { formatCreateTcuAppointmentErrorMessage } from "api/resources/messages/ErrorMessage";

const createTcuAppointments = async (
  params: CreateTcuAppointmentRequestPayload,
): Promise<CreateTcuAppointmentResponsePayload> => {
  try {
    const response = await axios.post<CreateTcuAppointmentResponsePayload>(
      CREATE_TCU_APPOINTMENT(),
      params,
      getRequestOptions(),
    );
    return parseResponse(response, CREATE_TCU_APPOINTMENT());
  } catch (error) {
    const msg = formatCreateTcuAppointmentErrorMessage(
      CREATE_TCU_APPOINTMENT(),
    );
    console.error(msg);
    throw error;
  }
};

export { createTcuAppointments };
